import { useState, useEffect } from 'react'

export const useGoalManager = () => {
  const [goals, setGoals] = useState([''])
  const [newGoalIndex, setNewGoalIndex] = useState(null)
  const [goalsAccordionOpen, setGoalsAccordionOpen] = useState(true)

  // Focus on newly added goal input
  useEffect(() => {
    if (newGoalIndex !== null) {
      setTimeout(() => {
        const newInput = document.querySelector(
          `input[data-goal-index="${newGoalIndex}"]`,
        )
        if (newInput) {
          newInput.focus()
          setNewGoalIndex(null) // Reset after focusing
        }
      }, 100)
    }
  }, [newGoalIndex])

  const handleGoalsAccordionToggle = () => {
    setGoalsAccordionOpen(!goalsAccordionOpen)
  }

  const addNewGoal = () => {
    const newIndex = goals.length
    setGoals([...goals, ''])
    setNewGoalIndex(newIndex)
  }

  const updateGoal = (index, value) => {
    const newGoals = [...goals]
    newGoals[index] = value
    setGoals(newGoals)
  }

  const handleGoalKeyPress = (event, index) => {
    if (event.key === 'Enter' && event.target.value.trim() !== '') {
      event.preventDefault()
      addNewGoal()
    }
  }

  const deleteGoal = index => {
    if (goals.length > 1) {
      const newGoals = goals.filter((_, i) => i !== index)
      setGoals(newGoals)
    }
  }

  return {
    goals,
    goalsAccordionOpen,
    handleGoalsAccordionToggle,
    addNewGoal,
    updateGoal,
    handleGoalKeyPress,
    deleteGoal, // Export the new function
  }
}
